const content = 
`
<p style="text-decoration: underline;font-weight: bold">
  请您在提交订单前谨慎完整的阅读以下买家须知（以下简称
  <strong>
    “
  </strong>
  规则
  <strong>
    ”
  </strong>
  ），并确保您在完全知情并接受本规则的情况下提交订单购买商品。如您不同意或不理解本规则内容的，您应停止提交订单。如您继续提交订单，则视为您认可并同意本规则的全部内容。本协议的订立、履行、效力、解释及争议的解决均适用《中华人民共和国合同法》及中华人民共和国其它法律法规。因订立或执行本协议而产生的任何争议，协议双方应首先通过协商解决。若协商不能解决，应提交本协议签订地即北京市海淀区人民法院诉讼。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  一、交易模式及流程
</p>
<p>
  1、图灵云仓App/微信小程序为用户提供网络经营场所、商品鉴别查验等服务，并据此收取相应服务费。<span style="text-decoration: underline;font-weight: bold">因此图灵云仓App/微信小程序仅为电子商务平台经营者，并非商品销售主体，不提供三包服务。</span>
</p>
<p>
  <br>
</p>
<p>
  2、图灵云仓App/微信小程序为图灵深视（北京）科技有限公司开发、运营、管理的一款为消费者提供闲置物品网络经营交易场所的软件产品，图灵云仓App/微信小程序仅就用户在图灵云仓App/微信小程序展示物品、服务信息、寻找交易对象并完成商品交易提供技术服务，同时为用户提供商品鉴别服务。
</p>
<p>
  <br>
</p>
<p>
  3、交易流程如下：
</p>
<p>
  卖家上架商品展示出售→买家下单→卖家发货到平台→平台多重检验→查验无误后平台发货到买家
</p>
<p>
  <br>
</p>
<p style="text-decoration: underline;font-weight: bold">
  4、买家委托图灵云仓App/微信小程序对于商品进行查验。买家知悉并同意图灵云仓App/微信小程序在买家确认收货后将买家支付的货款支付给卖家。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  二、发货时效
</p>
<p  style="text-decoration: underline;font-weight: bold">
  1、卖家于订单生效后的48小时内完成发货，平台在收货后全程视频监控，并在72小时内完成鉴别和查验。
</p>
<p>
  <br>
</p>
<p style="text-decoration: underline;font-weight: bold">
  2、买家同意授权平台在买家未付款、卖家未按时发货、商品鉴别不通过时，为保护买家利益，为买家关闭交易订单，买家所支付的货款在1-3个工作日内退还至用户钱包。
</p>
<p>
  <br>
</p>
<p style="text-decoration: underline;font-weight: bold">
  3、如遇节假日、平台大促活动或其他不可抗力因素（如地震、冰灾、交通事故等）导致的可能影响卖家发货的异常情况，具体发货时效请以商品详情页标注或平台公告为准。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  三、商品查验
</p>
<p style="text-decoration: underline;font-weight: bold">
  1、平台为交易双方提供商品实物鉴别服务，不通过的情况包括但不限于：
</p>
<p>
  <br>
</p>
<p>
  （1）商品是否存在明显与卖家描述不符的污渍、划痕、染色、破损、磨损等质量问题；
</p>
<p>
  （2）商品是否存在实物名称、款号、色号、尺码等与订单信息不符的情形；
</p>
<p>
  （3）商品是否存在与外盒（外包装）、配件不配套的情形；
</p>
<p>
  （4）商品是否存在缺少配件的情形，包括但不限于身份卡、肩带等；
</p>
<p>
  （5）商品是否存在与卖家描述不符的外包装破损、严重折痕及撕裂等情形；
</p>
<p>
  （6）商品是否存在明显与卖家描述不符的使用痕迹；
</p>
<p>
  （7）商品是否由平台鉴别是假冒商品；
</p>
<p>
  （8）商品是否存在其他影响商品外观完好的情形；
</p>
<p>
  （9）商品是否存在商品翻新，未告知或未完全告知的情况。
</p>
<p>
  <br>
</p>
<p style="text-decoration: underline;font-weight: bold">
  因商品生产制造工艺的问题，如商品出现包括但不限于自然褶皱、非完全对称、线头、折痕（可复原）、外包装轻微破损等情况，仅存在上述问题属于正常现象，平台查验后将视为查验通过正常发货。为确保商品的品质，平台会对商品拆封鉴别，鉴别通过后的商品会重新包装发货。
</p>
<p>
  <br>
</p>
<p style="text-decoration: underline;font-weight: bold">
  3、如果买家在收到商品后，对平台的鉴别查验结果存在质疑，可在签收
  <strong>
    24
  </strong>
  小时内并且未取防伪扣的情况下，与平台客服联系，申请双方认可的第三方鉴别并出具鉴别报告，如果鉴别结果与平台一致，并给平台造成损失的，买家承担赔偿责任。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  四、取消订单和确认收货
</p>
<p>
  1、<span style="text-decoration: underline;font-weight: bold">用户付款后无法自行取消订单，</span>若卖家未发货可联系客服取消，发货后将无法取消订单。
</p>
<p>
  2、如果卖家未能在48内发货，<span style="text-decoration: underline;font-weight: bold">平台将自动取消订单。</span>
</p>
<p style="text-decoration: underline;font-weight: bold">
  3、买家收到商品后可手动确认收货，买家未手动确认收货的，图灵云仓
  <strong>
    App/
  </strong>
  微信小程序将在物流显示已收货
  <strong>
    48
  </strong>
  小时后或物流发货满
  <strong>
    7
  </strong>
  日后自动确认收货。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  五、买家获得补偿的情形及补偿原则
</p>
<p style="text-decoration: underline;font-weight: bold">
  如果出现平台鉴别结果与平台认可的第三方鉴别机构给出的鉴别结果不符的情形，买家可以获得平台赔付，赔偿额度为鉴别金额的十倍。赔偿费用以以下形式发放至用户账户，包括但不限于：现金、平台优惠券、抵扣券，形式由平台根据运营计划灵活选择。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  六、确认收货及退换货声明
</p>
<p>
  1、图灵云仓App/微信小程序的出价模式为卖家出价模式，商品价格根据市场规律及卖家意愿波动较大，买家应按照心理价位进行购买，交易成功后不支持买家主张卖家退还差价。
</p>
<p>
  2、买家应知经由图灵云仓App/微信小程序出售的境内商品为卖家个人闲置物品。多数情况下卖家出售的同一商品同一型号规格仅为一件。因此非商品真假问题不支持
  <strong>
    7
  </strong>
  日无理由退换货服务。
</p>
<p>
  3、买家应在签收时仔细查验商品，如果发现真假问题应予以拒收，拒收商品应保持鉴别证书、防伪扣完好并连同原包装拒收，并在
  <strong>
    24
  </strong>
  小时内联系客服。如果买家签收后发现质量问题，应在收货后
  <strong>
    24
  </strong>
  小时内联系客服，并确保防伪扣、鉴别证书、原箱完好。如买家未及时联系客服或主张质量问题退回的商品符合本规则所述正常质量情况的，视为买家无故拒收，买家应支付全部货款。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  七、免责声明
</p>
<p style="text-decoration: underline;font-weight: bold">
  1、图灵云仓
  <strong>
    App/
  </strong>
  微信小程序抵制利用平台漏洞恶意刷单、套现的行为，平台一旦发现用户存在上述行为的，有权采取包括但不限于关闭交易订单、封禁用户账号、或采取进一步法律措施。
</p>
<p>
  2、由于众所周知的互联网技术因素等客观原因，平台显示的信息可能存在一定的滞后性或差错，对此情形买家知悉并了解。<span style="text-decoration: underline;font-weight: bold">因此，由于排版错误或信息错误导致商品以不正确或明显不合理的价格或信息显示的，平台有权取消该等不正确或明显不合理价格或信息的商品订单的权利。</span>
</p>
<p>
  3、因图灵云仓App/微信小程序并非商品销售主体，因此平台无法亦不支持开具商品销售发票。
</p>
<p>
  <br>
</p>
<p style="font-weight: bold">
  八、其他
</p>
<p>
  1、本规则由图灵云仓App/微信小程序制定并公示，图灵云仓App/微信小程序有权对本规则进行调整与修改，并向买家进行公示后执行。
</p>
<p>
  2、买家如对规则存在疑问，可联系客服进行咨询，联系方式：service@turingsenseai.com。
</p>
<p>
  <br>
</p>
`

export default {
  content,
  title: '图灵云仓买家协议'
}